/**
 * services.js
 */
$(function () {

    // enables data-toggle popover used in the service create form
    $(function () {
        $('[data-toggle="popover"]').popover();
    });
    // event listener to save details of the service
    $('.save').on('click', function(e) {
        e.preventDefault();

        let formData = $('.form-service').serializeArray();
        let id = $(this).attr('data-id');

        saveChangesToServiceForm(`/service-directory/create-service/${id}`, formData, 'save', 'POST');
    });


    // event listener to publish a service
    $('.service-form').on('click', '.publish-service', function(e) {
        e.preventDefault();

        let formData = $('.form-service').serializeArray();
        let id = $(this).closest('div').attr('data-id');

        if (!validateFieldsNotEmpty(formData)) {
            return Util.toggleAlert('#service-form-alert', 'Please edit and fill in all the required fields', 'alert-primary', 5000);
        }

        saveChangesToServiceForm(`/service-directory/publish-service/${id}`, formData, 'publish', 'PUT');
    });

    $(".back-button").on('click', function() {
        history.back();
    });


    // event listener to delete a service
    $('.delete').on('click', function(e) {
        e.preventDefault();
        $('#delete-service').modal('show');
    });

    // event listener to delete a service
    $('.delete-service').on('click', function(e) {
        e.preventDefault();
        let id = $('.service-form').attr('data-id');

        $('#delete-service').modal('hide');

        saveChangesToServiceForm(`/service-directory/delete-service/${id}`, '', 'delete', 'DELETE');
    });

    // event listener to unpublish a service
    $('.service-form').on('click', '.unpublish-service', function(e) {
        e.preventDefault();
        let id = $('.service-form').attr('data-id');

        saveChangesToServiceForm(`/service-directory/unpublish-service/${id}`, '', 'unpublish', 'PUT');
    });

    $('.modal-footer').on('click', '.unpublish-service', function(e) {
        e.preventDefault();
        $('.service-form .unpublish-service').trigger('click');
    });

});


// checks that the form is not empty, if only one field is empty it will return false
let validateFieldsNotEmpty = function(fields) {
    return !fields.some(function(field) {
        return !field.value && field.name.indexOf('end') < 0
    });
}
/**
 * saveChangesToServiceForm ajax request function to save details of services
 * @param {string} url - the endpoint to send the data to
 * @param {array} serviceData - the data to send in the request.
 * @param {string} type - type of button calling this ajax request - needed for the response.
 * @param {string} method - type of method to use in the ajax request - (POST/PUT/DELETE).
 */
let saveChangesToServiceForm = function (url, serviceData, type, method) {

    let csrf = Util.getCSRF();

    $.ajax({
        type: method,
        dataType: 'json',
        headers: {
            'isAPI': true,
            'x-csrf-token': csrf
        },
        url: url,
        data: serviceData
    }).done(function (response) {
        if (response) {
            switch (type) {
                case 'save':
                    $('.save').attr('data-id', response);
                    $('.cancel').text('Exit');
                    $('.service-form').removeClass('d-none');
                    $('.service-form').attr('data-id', response);
                    $('.service-form').html('<button type="button" class="btn btn-primary rounded mr-2 publish-service">Publish</button>');
                    return Util.toggleAlert('#service-form-alert', 'Service details saved succesfully.', 'alert-primary', -1);
                case 'publish':
                    $('.publish-service').remove();
                    $('.btn-edit').remove();
                    $('#delete-service .modal-body').html(
                        '<p>Do you wish to delete this service completely or just unpublish it from the service directory?</p>'
                    );
                    $('#delete-service .modal-footer').append(
                        '<button type="button" class="btn btn-primary unpublish-service">Unpublish Service</button>'
                    );
                    $('.service-form').append('<button type="button" class="btn btn-primary rounded mr-2 unpublish-service">Unpublish</button>');
                    return Util.toggleAlert('#service-form-alert', 'Service published.', 'alert-primary', -1);
                case 'unpublish':
                    $('.unpublish-service').remove();
                    $('#delete-service').modal('hide');
                    $('#delete-service .modal-body').html('<p>Do you wish to delete this service completely from the service directory?</p>');
                    $('.service-form').append('<button type="button" class="btn btn-primary rounded mr-2 publish-service">Publish</button>');
                    return Util.toggleAlert('#service-form-alert', 'Service unpublished.', 'alert-primary', -1);
                default:
                    window.location.href = '/service-directory/directory';
            }
        }

    }).fail(function(error) {
        let err = error.responseJSON.exception ? error.responseJSON.exception[0].message : error.responseJSON.message;
        return Util.toggleAlert('#service-form-alert', err, 'alert-warning', -1);
    });
}

/**
 * dateFormatter transforms timestamp value in readable date for the formatter column.
 * @param {string} value - the field value.
 * @param {object} row - the row record data.
 * @param {integer} index the row index
 */
 window.dateFormatter = function (value, row, index) {
    let date = convertDate(value);
    return date;
};

/**
 * convertDate transforms timestamp value in readable date
 * @param {string} timeStamp - the field value.
 */
let convertDate = function (timeStamp) {
    let today = new Date(timeStamp * 1000);
    return ('0' + today.getDate()).slice(-2) + '/' + ('0' + (today.getMonth() + 1)).slice(-2) + '/' + today.getFullYear();
}
